import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { messages } from "./languages";

// Respect the user's explicit language pick (saved to localStorage by
// the profile language switcher). Default to `he` for fresh installs
// because Whapiz is a Hebrew-first product for the Israeli market.
const savedLanguage = localStorage.getItem('language') || 'he';

// Debug: log messages structure
console.log("i18n messages structure:", Object.keys(messages));
console.log("Sample en structure:", messages.en ? Object.keys(messages.en) : "en not found");
console.log("Saved language from localStorage:", savedLanguage);

i18n
  .use(initReactI18next)
  .init({
    debug: false,
    lng: savedLanguage, // Set language explicitly
    defaultNS: ["translations"],
    fallbackLng: "en",
    ns: ["translations"],
    resources: messages,
    interpolation: {
      // escapeValue defaults to true. We previously set it to `false`
      // to allow inline markup inside translation strings, but that
      // also meant any `{{var}}` substituted from a backend payload
      // (queue names, customer-typed text echoed in error toasts,
      // tenant business names, etc.) was rendered raw — a stored-XSS
      // surface for any tenant whose admin pasted user-controlled
      // text into a label. Re-enable escaping; the few translation
      // strings that genuinely need HTML should switch to a Trans
      // component instead of relying on raw interpolation.
      escapeValue: true
    },
    react: {
      useSuspense: false
    }
  });

// Debug: expose i18n to window
if (typeof window !== 'undefined') {
  window.i18n = i18n;
}

export { i18n };
